export function useContent(): any {}
